import { useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { get } from '../apiClient'
import { residentMessageTimelineSchema } from '../../../common/validations/residentMessageTimelineSchema'

import { useCurrentContract } from 'hooks/useCurrentContract/useCurrentContract'

const path = (contractUuid: string) =>
  API_ENDPOINTS.MESSAGE_TIMELINE.replace(':contractUuid', contractUuid)

export const useAPIGetResidentMessageTimeline = () => {
  const { currentContractId: contractUuid } = useCurrentContract()

  return useSuspenseQuery({
    queryKey: ['resident-message-timeline', contractUuid],
    queryFn: async () => {
      const response = await get(
        path(contractUuid),
        residentMessageTimelineSchema
      )
      return response
    },
  })
}
